import { z } from "zod";
import type { KateMode } from "./ai-chat";
export const FIRST_BUILD_IMAGES = 50;
export const aiImageBudgetSchema = z.number().int().min(1).max(FIRST_BUILD_IMAGES);
export const EDIT_IMAGES = 6;
export function imageBudget(mode: KateMode, requested?: number) {
  return Math.min(requested ?? (mode === "build" ? FIRST_BUILD_IMAGES : EDIT_IMAGES), mode === "build" ? FIRST_BUILD_IMAGES : EDIT_IMAGES);
}
